import React, { useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { ImKey } from 'react-icons/im'
import { RiSecurePaymentFill } from 'react-icons/ri'
import { GiReceiveMoney, GiFlexibleStar } from 'react-icons/gi'
import { GoLaw } from 'react-icons/go'
import { BsPatchCheckFill } from 'react-icons/bs'
import { FaPenAlt, FaUserCircle } from 'react-icons/fa'
import { SiWebmoney } from 'react-icons/si'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import './styles.css'

export default function LandingHome() {
    return (
        <div className='landing-home'>
            <LandingWrapper>
                <Header />
                <Partenaire />
                <SignSomeClick />
                <Actualite />
                <Avantage />
                <SignatureElectronique />
                <Certificat />
            </LandingWrapper>
        </div>
    )
}

const Header = () => {
    return (
        <React.Fragment>
            <div className="landing-home__body-content">
                <div className='flip-header'>
                    <div className="landing-home__body-content-left">
                        <div className="landing-home__body-content-left-title">
                            <h1>Envoyez et signez</h1>
                            <h3>vos documents en ligne</h3>
                            <p>Où que vous soyez, en toute simplicité. <br />C’est rapide, facile et à moindre cout : essayez DKBSign dès maintenant.</p>
                        </div>
                        <div className="landing-home__body-content-left-button">
                            ESSAYER
                        </div>
                    </div>
                    
                    <div className="landing-home__body-content-right">
                        <img src="./assets/media/home_icon/Digital-Signature.png" className='landing-home__body-content-right_img_signataire' alt="landing-home__body-content-right_img_signataire" />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const Partenaire = () => {

    const [images, setImages] = useState([
        {
            id: 1,
            src: './assets/media/home_icon/ent_1.png',
            alt: 'image_entreprise'
        },
        {
            id: 2,
            src: './assets/media/home_icon/ent_2.png',
            alt: 'image_entreprise'
        },
        {
            id: 3,
            src: './assets/media/home_icon/ent_3.png',
            alt: 'image_entreprise'
        },
        {
            id: 4,
            src: './assets/media/home_icon/ent_4.png',
            alt: 'image_entreprise'
        },
        {
            id: 5,
            src: './assets/media/home_icon/ent_5.png',
            alt: 'image_entreprise'
        },
        {
            id: 6,
            src: './assets/media/home_icon/ent_6.png',
            alt: 'image_entreprise'
        },
        {
            id: 7,
            src: './assets/media/home_icon/ent_7.png',
            alt: 'image_entreprise'
        },
        {
            id: 8,
            src: './assets/media/home_icon/ent_8.jpg',
            alt: 'image_entreprise'
        },
        {
            id: 9,
            src: './assets/media/home_icon/ent_9.png',
            alt: 'image_entreprise'
        },
        {
            id: 10,
            src: './assets/media/home_icon/ent_10.png',
            alt: 'image_entreprise'
        },
        {
            id: 11,
            src: './assets/media/home_icon/ent_11.png',
            alt: 'image_entreprise'
        },
        {
            id: 12,
            src: './assets/media/home_icon/ent_12.png',
            alt: 'image_entreprise'
        }
    ])

    return (
        <div className="landing-partenaire">
            <p className="landing-partenaire__title">Ils nous font confiance</p>
            <div className="landing-partenaire__content">
                <marquee direction="left" scrollamount="10">
                    {images.map((image, index) => { return <ItemPartenaire image={image} key={index} /> })}
                </marquee>
            </div>
        </div>
    )
}

const SignSomeClick = () => {
    const [cards, setCards] = useState([
        {
            no: 1,
            title: 'Télécharger vos documents',
            description: 'Désignez les signataires, l\'emplacement des signatures et envoyez.'
        },
        {
            no: 2,
            title: 'Signez et faites signer',
            description: 'Chaques signataire est invité par e-mail a signer grace a la saisie d\'un code SMS.'
        },
        {
            no: 3,
            title: 'Conservez vos documents',
            description: 'Notre service de conservation a valeur probante sécurise le stockage du document signé.'
        }
    ])

    return (
        <div className="landing-some-click">
            <div className="landing-some-click-title">Signez simplement vos documents en quelques clics !</div>
            <div className="landing-some-click-cards">
                {cards.map((card, index) => { return <SignSomeClickCard card={card} key={index} /> })}
            </div>
        </div>
    )
}

const SignSomeClickCard = ({ card }) => {
    return (
        <div className="landing-some-click-card">
            <div className="landing-some-click-card__number">{card.no}</div>
            <div className="landing-some-click-card__content">
                <div className="landing-some-click-card__content-title">{card.title}</div>
                <div className="landing-some-click-card__content-description">{card.description}</div>
            </div>
        </div>
    )
}

const ItemPartenaire = ({ image }) => {
    return (
        <img className="landing-partenaire_items" src={image.src} alt={image.alt} />
    )
}

const Actualite = () => {
    return (
        <div className="landing-actualite">
            <p className="landing-partenaire__title">Actualités</p>
            <div className="landing-actualite__content">
                <ActualiteItem />
                <ActualiteItem />
                <ActualiteItem />
                <div style={{ marginLeft: '18px' }} className="we-trust-us_content-direction">
                    <BsArrowRight color='white' />
                </div>
            </div>

        </div>
    )
}

const ActualiteItem = () => {
    return (
        <div className="landing-actualite_items">
            <img src='./assets/media/home_icon/actu.jpg' className="landing-actualite_items-img" />

            <div className="landing-actualite_items-content">
                <div className="landing-actualite_items-content-description">Little desx</div>
                <div className="landing-actualite_items-content-title">Lorem ipsum dolor sit</div>

                <div className="landing-actualite_items-content-profile">
                    <FaUserCircle className="landing-actualite_items-content-profile-img" />
                    <div className="landing-actualite_items-content-profile-content">
                        <div className="landing-actualite_items-content-profile-content-name">Lorem ipsum</div>
                        <div className="landing-actualite_items-content-profile-content-date">Mars 28, 2023</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Avantage = () => {
    return (
        <div className="landing-avantage">
            <p className="landing-partenaire__title">Avantages de la signature <br /> électronique</p>
            <div className="landing-avantage_content">
                <div className="landing-avantage_range rang-1">
                    <div className="landing-avantage_range-items">
                        <ImKey className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Authentification</div>
                            <div className="landing-avantage_range-items-content">
                                Une signature électronique garantie l'authenticité d'un document signé où d'une transaction effectuée
                            </div>
                        </div>
                    </div>
                    <div className="landing-avantage_range-items">
                        <RiSecurePaymentFill className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Securisation</div>
                            <div className="landing-avantage_range-items-content">
                                La signature électronique garantie la sécurité d'un document car grâce à elle le doucument signé n'est en aucun cas modifiable
                            </div>
                        </div>
                    </div>
                    <div className="landing-avantage_range-items">
                        <GiReceiveMoney className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Economique</div>
                            <div className="landing-avantage_range-items-content">
                                Aujourd'hui nous vous donnons la possibilité de signer un document sans l’imprimer (économie de papier) & aussi l'envoyer de façon fiable par mail(économie de timbre)
                            </div>
                        </div>
                    </div>
                </div>
                <div className="landing-avantage_range rang-2">
                    <div className="landing-avantage_range-items">
                        <GoLaw className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Integrité</div>
                            <div className="landing-avantage_range-items-content">
                                Grâce à la signature éléctronique chaque document signé garde son intégrité car celà nous permet d'identifier les différents signataires en toute sérénité
                            </div>
                        </div>
                    </div>
                    <div className="landing-avantage_range-items">
                        <GiFlexibleStar className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Flexible</div>
                            <div className="landing-avantage_range-items-content">
                                Notre module de signature electronique s'adapte a tout type d'entreprise, grâce à notre API vous pourrez facilement l'intégrer à vos applications
                            </div>
                        </div>
                    </div>
                    <div className="landing-avantage_range-items">
                        <BsPatchCheckFill className='block-icon-avantages' />
                        <div className="landing-avantage_range-items-header">
                            <div className="block-text-avantages">Compatible</div>
                            <div className="landing-avantage_range-items-content">
                                Notre module de signature permet de signer des documents electroniques et aussi des transactions électroniques
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SignatureElectronique = () => {
    return (
        <div className="landing-electronic-sign">
            <p className="landing-partenaire__title">La signature électronique</p>
            <div className="landing-electronic-sign_content">
                <div className="landing-electronic-sign-items">
                    <FaPenAlt className='landing-electronic-sign-items-icon' />
                    <div className="landing-electronic-sign-items-title">Signature electronique</div>
                    <div className="landing-electronic-sign-items-content">DKB Sign donne la possibilité d’envoyer, de signer et de suivre n’importe quel type de document, à partir de tous les appareils, où que vous soyez.</div>
                </div>
                <div className="landing-electronic-sign-items">
                    <SiWebmoney className='landing-electronic-sign-items-icon' />
                    <div className="landing-electronic-sign-items-title">Digital Transaction Management</div>
                    <div className="landing-electronic-sign-items-content">DKB Sign, c’est bien plus que de la signature électronique. C’est la digitalisation de tous vos processus. Vous économisez de l’argent, augmentez votre productivité et améliorez la satisfaction de vos clients.</div>
                </div>
            </div>
        </div>
    )
}

const Certificat = () => {
    const [certificats] = useState([
        {
            id: 1,
            image: './assets/media/home_icon/cert_eidas.png',
            description: 'DKBSign est qualifié selon le règlement européen eIDAS'
        },
        {
            id: 2,
            image: './assets/media/home_icon/logo1.png',
            description: 'DKBSign est membre  de l\'organisation nationale des tiers de confiance numérique'
        },
        {
            id: 3,
            image: './assets/media/home_icon/gotic-removebg-preview.png',
            description: 'DKBSign est membre du Groupement des Opérateurs du Secteur des Technologies de l’Information et de la Communication de Côte d’Ivoire (GOTIC CI)'
        },
        {
            id: 4,
            image: './assets/media/home_icon/logo-LSTI-relief.png',
            description: 'DKBSolutions est certifié LSTI ETSI TS 102 042'
        },
        {
            id: 5,
            image: './assets/media/home_icon/ARTCI-removebg-preview.png',
            description: 'DKBSign est conforme aux exigences- de loi sur la protection des données à caractères personnel de l\'ARTCI'
        },
    ])

    return (
        <div className="dkd">
            <div className="landing-certificat">
                {certificats.map((certs) => (<CertificatItem key={certs.id} certs={certs} />))}
            </div>
            <div className="landing-certificat-desc">
                {certificats.map((certs) => (<CertificatItemDesc key={certs.id} certs={certs} />))}
            </div>
        </div>

    )
}

const CertificatItem = ({ certs }) => {
    return (
        <div className="landing-certificat_items">
            <img className='landing-certificat_items_img' src={certs.image} alt="certificat" />
        </div>
    )
}

const CertificatItemDesc = ({ certs }) => {
    return (
        <div style={{ height: '0px', justifyContent: 'normal' }} className="landing-certificat_items">
            <div className="landing-certificat_items-description">{certs.description}</div>
        </div>
    )
}